<template>
  <v-container fill-height>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <h1>{{ $t('coming_soon.txt.title') }}</h1>

        <v-img
          :src="$t('coming_soon.img.trucks.img')"
          class="my-8"
        />
        <p>{{ $t('coming_soon.txt.text') }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ComingSoon'
}
</script>

<style lang="scss">
h1 {
  font-size: 3rem;
  font-weight: normal;
  line-height: normal;
  color: var(--v-dark-base);
  text-align: center;
}
p {
  font-size: 0.875rem;
  color: var(--v-slate-base);
  text-align: center;
}
</style>
